import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { isBusinessApiUrl } from '@zeusm/shared/core/helpers';
import { getPersistedActiveBusinessProfileId } from '@zeusm/shared/session/profile/helpers';

const BUSINESS_PROFILE_ID_HEADER = 'Business-Profile-Id';

/** Adds the active business profile id to business API requests. */
export function businessProfileInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (!isBusinessApiUrl(request.url)) {
    return next(request);
  }

  const activeBusinessProfileId = getPersistedActiveBusinessProfileId();

  if (!activeBusinessProfileId) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        [BUSINESS_PROFILE_ID_HEADER]: activeBusinessProfileId,
      },
    }),
  );
}
